export default {
  retail: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbSolutions: 'الحلول',
    breadcrumbCurrent: 'التجزئة والمطاعم',
    hero: {
      eyebrow: 'التجزئة والمطاعم',
      title: 'مزيد من الأمان في المتاجر والمطاعم',
      lead: 'المدخل ومنطقة الدفع والمستودع ومدخل المطبخ – نحمي نشاطك من السرقة والتخريب دون إزعاج عملائك.',
    },
    points: {
      title: 'نقاط المراقبة للتجزئة والمطاعم',
      lead: 'لكل متجر ومنشأة مطاعم مناطق خطر خاصة به. نضع الكاميرات بالضبط حيث تُحدث فرقًا.',
      items: {
        '0': { title: 'المدخل والواجهة', desc: 'أول نقطة مراقبة: كاميرات المدخل توثّق من يدخل ويخرج وتردع منذ اللحظة الأولى.' },
        '1': { title: 'منطقة الدفع', desc: 'الصندوق ومنطقة الدفع هما النقطة الأكثر حساسية في التجارة. كاميرات سرية تؤمّن المنطقة دون إقلاق العملاء.' },
        '2': { title: 'سطح البيع', desc: 'رؤية كاملة للمساحة: كاميرات الزاوية الواسعة تكتشف الحركات المشبوهة بين الرفوف والممرات.' },
        '3': { title: 'المستودع والتوريد', desc: 'استلام البضائع والمستودع ومداخل الموظفين: تظهر هنا ثغرات عند دخول البضائع وخروجها. نسدّها.' },
        '4': { title: 'المنضدة ومدخل المطبخ', desc: 'في المطاعم، المنضدة ومدخل المطبخ منطقتان حرجتان. كاميرات متينة تتحمل الرطوبة والحرارة.' },
        '5': { title: 'الجلوس الخارجي والشرفة', desc: 'الشرفة والجلوس الخارجي دعوة للصوص، خاصة مساءً. كاميرات مقاومة للطقس تراقب.' },
      },
    },
    protection: {
      eyebrow: 'الحماية من السرقة',
      title: 'خسائر أقل في الجرد، أمان أكثر',
      lead: 'سرقة المتاجر وفروق الجرد تكلف التجارة مبالغ كبيرة كل عام. كاميرات موضوعة جيدًا تقلل الخسائر وتوفر صورًا مفيدة عند الحاجة.',
      items: {
        '0': { title: 'مراقبة منطقة الدفع', desc: 'صور حادة للصندوق ومنطقة الدفع – لتوثيق كامل في حالات النزاع والتلاعب.' },
        '1': { title: 'الواجهات والمداخل', desc: 'ردع وتوضيح عند التخريب أو الاقتحام – من الواجهة إلى المدخل الخلفي.' },
        '2': { title: 'سجلات الأحداث', desc: 'الحركة أو عبور الخط أو أحداث الأبواب تفعّل التسجيل والإشعارات الفورية – عند الحاجة تمامًا.' },
      },
    },
    gastro: {
      eyebrow: 'المطاعم',
      title: 'تقنية متينة للمنضدة والمطبخ والشرفة',
      lead: 'البخار والدهون والرطوبة تفرض متطلبات خاصة على التقنية. نختار كاميرات تعمل بموثوقية في يوميات المطاعم ولا يشعر بها الضيوف.',
      list: {
        '0': 'مراقبة مدخل المطبخ – دخول الموظفين المصرح لهم فقط',
        '1': 'تأمين المنضدة ومنطقة الدفع دون إزعاج الضيوف',
        '2': 'مراقبة الجلوس الخارجي والشرفة في ساعات المساء',
        '3': 'توثيق الموردين والتوريد دون ثغرات',
        '4': 'وضع لافتات إرشادية للضيوف والموظفين',
      },
      note: 'ملاحظة: تعتمد شرعية المراقبة بالفيديو على الحالة الفردية. ننصحك دون أن نغني عن الاستشارة القانونية.',
    },
    cta: {
      title: 'نشاطك يستحق إطارًا آمنًا',
      lead: 'نُريك دون التزام أين تكون المراقبة مجدية لك – وأين لا تكون ضرورية.',
      primary: 'احجز موعد استشارة',
      secondary: 'اكتشف SSG Care',
    },
  },
};